import { useNavigate } from 'react-router-dom'
import { KTIcon } from '../../../../../../_metronic/helpers'
import type { Gap } from '../model/coverage'
import { FlagChip } from './FlagChip'
import { contextLabel } from '../labels'

interface Props {
  gaps: Gap[]
  merchantTitle: (token: string) => string
  /** Only a writer gets the template link; a reader would open an editor it cannot save. */
  canWrite: boolean
}

/**
 * "Требуют настройки" — expected contexts with no active configuration. Rendered
 * as a Metronic warning panel; each row links to the editor pre-filled from a
 * template (?template=1) so the operator does not start from scratch.
 */
export const GapsBlock = ({ gaps, merchantTitle, canWrite }: Props) => {
  const navigate = useNavigate()

  if (gaps.length === 0) {
    return (
      <div className='notice d-flex bg-light-success rounded border-success border border-dashed p-5 mb-2'>
        <KTIcon iconName='shield-tick' className='fs-2x text-success me-4' />
        <div className='d-flex flex-stack flex-grow-1'>
          <div className='fw-semibold fs-6 text-gray-700'>
            Пропусков нет — все ожидаемые контексты имеют активную конфигурацию.
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-5 mb-2'>
      <KTIcon iconName='information-5' className='fs-2x text-warning me-4' />
      <div className='d-flex flex-column flex-grow-1'>
        <div className='fw-bold fs-5 text-gray-900 mb-3'>
          Требуют настройки ({gaps.length})
        </div>
        <div className='fs-7 text-gray-600 mb-4'>
          Эти контексты используются мерчантами, но не имеют активной конфигурации — платежи в них
          не маршрутизируются.
        </div>
        <div className='d-flex flex-column gap-2'>
          {gaps.map((gap) => (
            <div
              key={gap.contextId}
              className='d-flex align-items-center justify-content-between bg-body rounded px-4 py-3'
            >
              <div className='d-flex align-items-center flex-wrap gap-2'>
                <span className='fw-bold text-gray-900'>
                  {merchantTitle(gap.context.merchantToken)}
                </span>
                <FlagChip flag={gap.context.externalUserFlag} />
                <span className='text-gray-600 fs-7'>{contextLabel(gap.context)}</span>
              </div>
              {canWrite && (
                <button
                  type='button'
                  className='btn btn-sm btn-light-warning'
                  onClick={() =>
                    navigate(`/settings/adapter-routing/config/${gap.contextId}?template=1`)
                  }
                >
                  <KTIcon iconName='abstract-26' className='fs-5 me-1' />
                  Заполнить из шаблона
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
